<template>

  <multiselect ref="selectTag"
               :class="{'select-tag-multiselect': true}"
               :options="tags"
               :searchable="false"
               :hide-selected="true"
               :max-height="240"
               :reset-after="true"
               open-direction="top"
               :show-labels="false"
               @close="selectClose"
               @select="selectMergeTag"
  >
    <div slot="beforeList" class="tags-header">
      <div>Merge Tags</div>
      <span>Select a Merge Tag to Customize the Message for each person that receives it</span>
    </div>
    <template slot="option" slot-scope="props">
      <div class="option__desc row">
        <div class="option__title col-xs-5">{{ props.option.name }}</div>
        <div class="option__small option_tag col-xs-4">{{ props.option.usage }}</div>
        <div class="option__small col-xs-3 text-right">{{ props.option.example }}</div>
      </div>
    </template>
  </multiselect>


</template>

<script>
  /*eslint-env jquery*/
  import {getAvailableMergeTags} from '../../utils/api';

  import Multiselect from 'vue-multiselect';

  export default {
    name: 'SelectTags',
    components: {
      Multiselect,
    },
    props: [
      'blockId',
    ],
    beforeDestroy() {
      window.mergeTags = this.$root.mergeTags;
    },
    mounted() {
      const msgId = this.$route.params.msgId;
      if (msgId) {
        getAvailableMergeTags(msgId).then(tags => {
          const mergeTags = tags.tags.filter(
            tag => !tag.usage.includes('has_donated') && !tag.usage.includes('has_not_donated'));

          window.mergeTags = mergeTags;
          this.mergeTags = mergeTags;
        });
      }
    },
    methods: {
      toggle() {
        this.$refs.selectTag.toggle();
      },
      selectMergeTag(value) {
        const self = this;

        function insertHTML(insertTag) {

          const innerHtml = insertTag.replaceAll('[', '<span class="merge-tag-edit">[').
            replaceAll(']', ']</span>\u00A0');

          if (!document.execCommand('insertHTML', false, innerHtml)) {
            $('#' + self.blockId).data('emojioneArea').setFocus();
            document.execCommand('insertHTML', false, innerHtml);
          }

//        $('#new-msg').data('emojioneArea').editor.html()

//          let sel, range, isSpaceBefore = false;
//          if (window.getSelection && (sel = window.getSelection()).rangeCount) {
//            range = sel.getRangeAt(0);
//
//            let insertTag = value.usage;
//
//            const range2 = range.cloneRange();
//            range2.collapse(true);
//            range2.setStart($('#new-msg').data('emojioneArea').editor[0], 0);
//            const precedingChar = range2.toString().slice(-1);
//
//            if (precedingChar.match(/^\s+$/)) {
//              isSpaceBefore = true;
//            }
//
//            range.collapse(true);
//
//            const block = document.createElement('span');
//
//            insertTag = insertTag.replaceAll('[', '<span class="merge-tag-edit">[').replaceAll(']', ']</span>');
//
//            block.innerHTML = (isSpaceBefore ? '' : '\u00A0') +
//              `${insertTag}\u00A0`;
//
//            range.insertNode(block);
//            // Move the caret immediately after the inserted block
//            range.setStartAfter(block);
//            range.collapse(true);
//            sel.removeAllRanges();
//            sel.addRange(range);
//          }
        }

        insertHTML(value.usage);
        this.$emit('txt-change');
      },
      selectClose() {
        this.$nextTick(() => {
          $('#' + this.blockId).data('emojioneArea').setFocus();
        });
      },
    },
    computed: {
      tags(){
        return this.mergeTags?this.mergeTags:this.$root.mergeTags;
      },
    },
    data() {
      return {
        text: '',
        mergeTags: null
      };
    },
  };
</script>

<style lang="sass">
  .multiselect.select-tag-multiselect
    z-index: 10000
    min-height: 0
    width: 100%
    .multiselect__tags,
    .multiselect__select
      display: none
</style>
